import { ref } from 'vue'
import { isMobile } from './breakpoints'

const ANIMATION_SHIFT = 400
const ANIMATION_DURATION = 600

const MOBILE_BAR_HEIGHT = 56
const MOBILE_NAV_HEIGHT = 64

const DASHBOARD_WIDTH = {
  full: 280,
  collapsed: 80,
}
const isOpenBoard = ref(true)
const mobileTitle = ref('')

const contentWidth = computed(() =>
  isMobile.value ? contentWidthDesktop.value : 0
)
const contentWidthDesktop = computed(() =>
  isOpenBoard.value ? DASHBOARD_WIDTH.full : DASHBOARD_WIDTH.collapsed
)

const scrollContainer = ref()

const toggleDashBoard = () => (isOpenBoard.value = !isOpenBoard.value)

export {
  DASHBOARD_WIDTH,
  isOpenBoard,
  toggleDashBoard,
  ANIMATION_SHIFT,
  ANIMATION_DURATION,
  contentWidth,
  MOBILE_BAR_HEIGHT,
  MOBILE_NAV_HEIGHT,
  scrollContainer,
  mobileTitle,
}
